/* Nach "In den Warenkorb" immer auf /cart weiterleiten (ohne Drawer) */
(function () {
  // 1) Klassische Produktformulare (/cart/add)
  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!form || form.tagName !== "FORM") return;

      const action = (form.getAttribute("action") || "").trim();
      if (!action.includes("/cart/add")) return;

      // Wir übernehmen den Add-to-cart, damit es zuverlässig funktioniert (auch bei Ajax-Themes)
      e.preventDefault();

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      })
        .then(async (res) => {
          if (!res.ok) {
            let msg = "Konnte nicht in den Warenkorb legen.";
            try {
              const j = await res.json();
              if (j && (j.description || j.message)) msg = j.description || j.message;
            } catch (_) {}
            throw new Error(msg);
          }
          return res.json();
        })
        .then(() => {
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.error("[cart redirect] add failed:", err);
          alert(err.message || "Konnte nicht in den Warenkorb legen.");
        });
    },
    true
  );

  // 2) Fallback für "Quick Add"/Ajax-Buttons, die direkt fetch zu /cart/add machen
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    return origFetch.apply(this, args).then((res) => {
      try {
        const url =
          typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
        if (url.includes("/cart/add") && res && res.ok) {
          // kleiner Delay, damit Shopify den Cart sauber aktualisiert
          setTimeout(() => (window.location.href = "/cart"), 150);
        }
      } catch (_) {}
      return res;
    });
  };
})();
